// The ONE sheet per avoir kind, whoever opens it: a credit note (correction) is always CreditNoteSheet (what the registry opens), a goodwill voucher (commercial) AvoirQuickView.
import React from 'react';
import { AvoirQuickView } from './AvoirBits';
import CreditNoteSheet from './CreditNoteSheet';

export default function AvoirView({ commercial = false, ...p }) {
  return commercial ? <AvoirQuickView {...p} /> : <CreditNoteSheet {...p} />;
}
